exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".description[data-v-902883d6] {\n  line-height: 1.2;\n}", ""]);

// exports
